module.exports = __webpack_public_path__ + "img/logo.c2882e48.png";